import React from 'react';

import ReactDOM from 'react-dom';

import { AddToTestCycleDialog } from '@qality/common-components';

export default {
  openAddToTestCycleDialog(testCaseIds: Array<number>): void {
    const modalElem: any = document.getElementById(
      'com_soldevelo_apps_test-management_dialog'
    );
    ReactDOM.render(
      <AddToTestCycleDialog testCaseIds={testCaseIds} onClose={closeDialog} />,
      modalElem
    );
  },
};

const closeDialog = () => {
  const remove: Element = document.querySelector(
    '#com_soldevelo_apps_test-management_dialog'
  );
  ReactDOM.unmountComponentAtNode(remove);
};
